export const specials = [
  {
    id: "hidden-tension",
    title: "都市情感里的隐秘张力",
    kicker: "专题策划 · 情感观察",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20two%20people%20sitting%20apart%20in%20a%20dim%20apartment%20living%20room%20at%20night%2C%20warm%20lamp%20light%20and%20deep%20navy%20shadows%2C%20quiet%20tension%2C%20film%20grain%2C%20no%20text&width=1200&height=800&seq=special-hidden-tension&orientation=landscape",
    intro:
      "当亲密关系不再靠宣言推进，而是靠沉默、试探和一次没有发生的对话，都市情感剧才真正开始好看。这个专题挑出三部把「张力」拍进日常的作品。",
    movieIds: ["chunri-chichi", "er-ci-gao-bai", "ta-yu-shan-hai"],
    reasons: [
      "三部剧都把冲突放在作息、空间与沉默里，而不是狗血误会。",
      "共同点是极强的细节密度：一碗汤、一张明信片、一句没说完的话。",
      "适合喜欢慢慢看、愿意在台词之外读情绪的观众。",
    ],
    relatedIds: ["reversal-map", "old-times"],
  },
  {
    id: "reversal-map",
    title: "悬疑剧的多重反转地图",
    kicker: "专题策划 · 结构拆解",
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20cinematic%20still%20of%20a%20rain-soaked%20city%20map%20pinned%20with%20red%20strings%20on%20a%20wall%2C%20single%20warm%20lamp%2C%20deep%20navy%20palette%2C%20mystery%20atmosphere%2C%20no%20text&width=1200&height=800&seq=special-reversal-map&orientation=landscape",
    intro:
      "反转不是把观众骗一次，而是让观众在第二次观看时依然信服。我们用四部剧拆解「有效反转」的三个前提：公平的线索、可信的动机、以及不背叛人物的结局。",
    movieIds: ["an-yong", "bai-ta-zhi-xia", "wu-zhong-lie-che", "chang-an-ye-xing"],
    reasons: [
      "四部剧都遵守「线索公平」原则，关键信息在揭晓前已经出现。",
      "反转之后人物关系会重新排列，而不是仅仅换个凶手。",
      "适合喜欢二刷、做笔记的硬核观众。",
    ],
    relatedIds: ["hidden-tension", "ancient-aesthetic"],
  },
  {
    id: "old-times",
    title: "年代剧里的旧时光",
    kicker: "专题策划 · 时代切片",
    cover:
      "https://readdy.ai/api/search-image?query=Nostalgic%20still%20of%20an%20old%20harbor%20warehouse%20interior%20with%20wooden%20crates%20and%20dusty%20light%20beams%2C%20sepia%20and%20faded%20teal%20palette%2C%20analog%20film%20grain%2C%20no%20text&width=1200&height=800&seq=special-old-times&orientation=landscape",
    intro:
      "年代剧真正的价值，不在于复刻旧物，而在于还原一种已经消失的生活逻辑。两部作品，一条码头，一座山村，两种关于「留下」的答案。",
    movieIds: ["jiu-gang-wang-shi", "qun-shan-hui-xiang"],
    reasons: [
      "都以群像代替主角英雄主义，时代是真正的主角。",
      "道具与空间承担叙事功能：账册、名单、码头、教室。",
      "适合想安静看完一段长故事的观众。",
    ],
    relatedIds: ["ancient-aesthetic", "hidden-tension"],
  },
  {
    id: "ancient-aesthetic",
    title: "古装新美学：废墟、雪与一盏灯",
    kicker: "专题策划 · 视觉研究",
    cover:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20architecture%20at%20night%20with%20falling%20snow%20and%20warm%20lantern%20glow%2C%20deep%20ink%20blue%20palette%2C%20elegant%20cinematic%20composition%2C%20no%20text&width=1200&height=800&seq=special-ancient-aesthetic&orientation=landscape",
    intro:
      "当古装剧不再依赖金碧辉煌，而是用雪、雾、废墟和单一光源讲故事，一种更克制的东方美学正在成型。我们从两部作品看这套视觉语言的建立。",
    movieIds: ["gui-xu", "chang-an-ye-xing"],
    reasons: [
      "都在美术上做减法：低饱和配色、单体光源、大面积留白。",
      "视觉风格与叙事气质高度统一，不是单纯的「好看」。",
      "适合对摄影与美术感兴趣的观众。",
    ],
    relatedIds: ["reversal-map", "old-times"],
  },
];